import { useRef } from "react";
import { usePageSEO } from "@/hooks/usePageSEO";
import EditorialHeader from "@/components/editorial/EditorialHeader";
import EditorialHero from "@/components/editorial/EditorialHero";
import AnimatedBorderBadge from "@/components/editorial/AnimatedBorderBadge";
import EditorialIntegrationBanner from "@/components/editorial/EditorialIntegrationBanner";
import EditorialPlatformSection from "@/components/editorial/EditorialPlatformSection";
import EditorialVideoShowcaseSection from "@/components/editorial/EditorialVideoShowcaseSection";
import EditorialTrialCTA from "@/components/editorial/EditorialTrialCTA";
import EditorialUGCAdsSection from "@/components/editorial/EditorialUGCAdsSection";
import EditorialMultiPlatformSection from "@/components/editorial/EditorialMultiPlatformSection";
import EditorialPlanningSection from "@/components/editorial/EditorialPlanningSection";
import EditorialPlatformSectionAlt from "@/components/editorial/EditorialPlatformSectionAlt";
import EditorialPricingSummary from "@/components/editorial/EditorialPricingSummary";
import EditorialStatsBar from "@/components/editorial/EditorialStatsBar";

import EditorialVideoTestimonials from "@/components/editorial/EditorialVideoTestimonials";
import EditorialFAQ from "@/components/editorial/EditorialFAQ";
import YourStoryAppSection from "@/components/sections/YourStoryAppSection";
import EditorialFooter from "@/components/editorial/EditorialFooter";
import EditorialGridLayout from "@/components/editorial/EditorialGridLayout";
import EditorialSectionDivider from "@/components/editorial/EditorialSectionDivider";
import GridLinesWrapper from "@/components/editorial/GridLinesWrapper";


const HomeExperimental3 = () => {
  const pricingRef = useRef<HTMLElement>(null);
  usePageSEO({
    title: 'Storily | Marketing Automation Platform',
    description: 'The All-in-One Marketing & Lead Management Platform for Business Owners & Agencies.',
    canonical: 'https://storily.io/',
    keywords: 'marketing automation, lead management, business marketing platform'
  });

  const testimonials = [
    {
      id: 1,
      videoUrl: "https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/YourStory%20Testimonial%20Style%20UGC%20-%20Linda%20Vittoria%20(1).mp4",
      thumbnail: "https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/images/Screenshot%202025-10-23%20211814.png"
    },
    {
      id: 2,
      videoUrl: "https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/Story%20Marketing.mp4",
      thumbnail: "https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/images/Screenshot%202025-10-25%20202529.png"
    },
    {
      id: 3,
      videoUrl: "https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/Time-Saving%20Platform%20Empowerment%20Story.mp4",
      thumbnail: "https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/images/Screenshot%202025-10-22%20210154.png"
    },
    {
      id: 4,
      videoUrl: "https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/pro%20vision%20ver1.mp4",
      thumbnail: "https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/images/Screenshot%202025-10-22%20154250.png"
    },
    {
      id: 5,
      videoUrl: "https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/Fiverr_Story%20(1).mp4",
      thumbnail: "https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/images/Screenshot%202025-10-22%20205432.png"
    },
    {
      id: 6,
      videoUrl: "https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/video-content/Story_Marketing%20(2).mp4",
      thumbnail: "https://kpaixcycljzsxxriyzjh.supabase.co/storage/v1/object/public/images/Screenshot%202025-10-25%20202907.png"
    }
  ];

  return (
    <>
      <EditorialGridLayout>
        
        <div className="min-h-screen overflow-x-hidden">
          <EditorialHeader />
        <main>
          <EditorialHero />
          <EditorialSectionDivider className="my-2" />
          <EditorialIntegrationBanner />
          <EditorialSectionDivider />
          <GridLinesWrapper className="bg-[#f4f2f1] dark:bg-[#111111]">
            <EditorialVideoShowcaseSection />
          </GridLinesWrapper>
          <EditorialSectionDivider />
          <EditorialPlatformSection />
          <EditorialSectionDivider />
          <GridLinesWrapper>
            <EditorialStatsBar />
          </GridLinesWrapper>
          <EditorialSectionDivider />
          <div>
            <GridLinesWrapper>
              <EditorialUGCAdsSection />
            </GridLinesWrapper>
            <EditorialSectionDivider />
            <GridLinesWrapper>
              <EditorialMultiPlatformSection />
            </GridLinesWrapper>
            <EditorialSectionDivider />
            <GridLinesWrapper>
              <EditorialPlanningSection />
            </GridLinesWrapper>
            <EditorialSectionDivider />
            {/* Testimonials */}
            <GridLinesWrapper>
              <EditorialVideoTestimonials testimonials={testimonials} />
            </GridLinesWrapper>
            <EditorialSectionDivider />
          </div>
          <GridLinesWrapper>
            <EditorialPricingSummary ref={pricingRef} />
          </GridLinesWrapper>
          <GridLinesWrapper>
            <EditorialPlatformSectionAlt />
          </GridLinesWrapper>
          <EditorialSectionDivider />
          <GridLinesWrapper>
            <EditorialSectionDivider />
            <EditorialFAQ />
          </GridLinesWrapper>
          <GridLinesWrapper>
            <EditorialTrialCTA />
          </GridLinesWrapper>
          <EditorialSectionDivider />
          <GridLinesWrapper className="bg-[#f4f2f1] dark:bg-[#111111] transition-colors duration-300" horizontalGap>
            <YourStoryAppSection />
          </GridLinesWrapper>
          <EditorialSectionDivider />
        </main>
        <EditorialFooter />
      </div>
    </EditorialGridLayout>
    </>
  );
};

export default HomeExperimental3;
